module.exports = __webpack_public_path__ + "static/media/galdisa_logo.ea4ec3f2.png";